export default {
  stateKey: 'bold',
  order: 3,
  commandKey: 'toggleBold',
  icon: ['far', 'bold'],
  appearance: {
    menu: true,
    bubble: true,
  },
}
